import { memo, useState } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

import { RangePicker } from './rangePicker'

import { TextInput } from '../../inputs/text'
import { Button } from '../../buttons/button'
import { SearchIcon as IconSearch } from '../../icons/search'

const SearchIcon = () => <IconSearch color="white" />
const Form = styled.form`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;

  button {
    margin: 0 0 0 16px;
  }
`
const SearchComponent = ({
  query,
  onChange,
  onClear,
  onSubmit,
  isDisabled,
  onRangeClear,
  dateRangePicker
}) => {
  const [startDate, setStartDate] = useState(null)
  const [endDate, setEndDate] = useState(null)
  const handleOnSubmit = evt => {
    let range = []

    if (startDate || endDate) {
      const { minStartDate, maxEndDate } = dateRangePicker

      range = [startDate || minStartDate, endDate || maxEndDate]
    }

    evt.preventDefault()

    onSubmit(range)
  }

  return (
    <Form onSubmit={handleOnSubmit}>
      <TextInput
        size="small"
        value={query}
        placeholder="Search"
        icon={SearchIcon}
        onChange={evt => onChange(evt.target.value)}
        onClear={onClear}
        isDisabled={isDisabled}
      />
      {dateRangePicker && (
        <RangePicker
          startDate={startDate}
          endDate={endDate}
          minStartDate={dateRangePicker.minStartDate}
          maxEndDate={dateRangePicker.maxEndDate}
          onStartDateChange={setStartDate}
          onEndDateChange={setEndDate}
          onClear={onRangeClear}
        />
      )}
      <Button size="small" type="submit" isDisabled={query === ''} display="default">
        Search
      </Button>
    </Form>
  )
}
const Search = memo(SearchComponent)

SearchComponent.propTypes = {
  query: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  onClear: PropTypes.func,
  isDisabled: PropTypes.bool,
  onRangeClear: PropTypes.func,
  dateRangePicker: PropTypes.oneOfType([PropTypes.bool, PropTypes.object])
}

export { Search }
